var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultAvatar9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1078_9299)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "#FEB173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 14.5C29 20.0234 25.9123 24.8248 21.3687 27.2725C19.3248 28.3746 16.9856 29 14.5005 29C12.0153 29 9.67517 28.3746 7.63038 27.2725C3.0877 24.8239 0 20.0225 0 14.5C0 6.49246 6.49175 0 14.5005 0C22.5092 0 29 6.49246 29 14.5Z",
    fill: "#FEB173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3687 27.2724C19.3249 28.3746 16.9856 28.9999 14.5005 28.9999V22.2559H16.3566V25.6735C17.6538 25.9597 18.9219 26.3034 20.1389 26.7528C20.4042 26.8376 20.696 26.9488 21.005 27.0919C21.0086 27.0938 21.0132 27.0956 21.0178 27.0974C21.1326 27.1521 21.2493 27.2095 21.3687 27.2724Z",
    fill: "#08BED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5004 22.2559V28.9999C12.0153 28.9999 9.67517 28.3746 7.63037 27.2724C7.7498 27.2095 7.8674 27.1521 7.98226 27.0983C7.98682 27.0956 7.99138 27.0938 7.99502 27.0919C8.30407 26.9488 8.59579 26.8376 8.86108 26.7528C10.0781 26.3034 11.3462 25.9597 12.6434 25.6735V22.2559H14.5004Z",
    fill: "#0691AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4994 4.18555C9.99682 4.33505 6.39404 7.92313 6.39404 12.3289C6.39404 16.7347 9.86008 24.446 14.4994 24.446V4.18555Z",
    fill: "#0691AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4995 4.18555C19.0021 4.33505 22.6049 7.92313 22.6049 12.3289C22.6049 16.7347 19.1388 24.446 14.4995 24.446V4.18555Z",
    fill: "#08BED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1914 16.9929C20.7961 18.7013 21.623 13.5662 21.623 13.5662C21.623 13.5662 16.8998 11.3874 15.1914 16.9929Z",
    fill: "#024C74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37695 13.5669C7.37695 13.5669 8.20289 18.7019 13.8085 16.9936C12.1001 11.389 7.37695 13.5669 7.37695 13.5669Z",
    fill: "#024C74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2188 19.1577C14.2188 19.3428 14.0684 19.4932 13.8833 19.4932C13.6983 19.4932 13.5479 19.3428 13.5479 19.1577C13.5479 18.9727 13.6983 18.8223 13.8833 18.8223C14.0684 18.8223 14.2188 18.9727 14.2188 19.1577Z",
    fill: "#024C74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1167 19.4932C15.302 19.4932 15.4522 19.343 15.4522 19.1577C15.4522 18.9725 15.302 18.8223 15.1167 18.8223C14.9315 18.8223 14.7812 18.9725 14.7812 19.1577C14.7812 19.343 14.9315 19.4932 15.1167 19.4932Z",
    fill: "#024C74"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1078_9299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar9);
export default __webpack_public_path__ + "static/media/default-avatar-9.313caa137ad23911d596f3dfdfd9291e.svg";
export { ForwardRef as ReactComponent };